import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";

// Create a connector
let connector;
const callConst = () => {
  connector = new WalletConnect({
    bridge: "https://bridge.walletconnect.org", // Required
    qrcodeModal: QRCodeModal,
  });
};

export const connectWallet = async (walletType, d) => {
  callConst();
  return new Promise((resolve) => {
    try {
      // Check if connection is already established
      if (!connector.connected) {
        // create new session
        connector.createSession();
        console.log(connector, 'setCookie("walletconnect")');
      }
      // Listen for the QR Code Modal's 'modal_closed' event (I found it when looking here: https://github.com/WalletConnect/walletconnect-monorepo/blob/7573fa9e1d91588d4af3409159b4fd2f9448a0e2/packages/providers/web3-provider/src/index.ts#L222)
      connector.on("modal_closed", () => {
        callConst();
      });
      connector.on("connect", (error, payload) => {
        if (error) {
          console.log("error", error);
          resolve({ address: "", chainId: "" });
        } else {
          // Get provided accounts and chainId
          const { accounts, chainId } = payload.params[0];
          resolve({ address: accounts[0], chainId });
        }
      });
    } catch (err) {
      console.log("err", err);
      resolve({ address: "", chainId: "" });
    }
  });
};

export const getCurrentWalletConnected = async () => {
  try {
    return { address: connector.accounts[0] };
  } catch (err) {
    return { address: "" };
  }
};

export const getCurrentChain = () => {
  try {
    return connector.chainId;
  } catch (err) {
    return "";
  }
};

export const onSessionUpdate = (callback) => {
  try {
    connector.on("session_update", (error, payload) => {
      if (error) {
        throw error;
      }

      // Get updated accounts and chainId
      const { accounts, chainId } = payload.params[0];
      callback({ accounts, chainId });
    });
  } catch (err) {}
};

export const sendTransaction = (params) => {
  try {
    return connector.sendTransaction(params);
  } catch (err) {}
};

export const switchChain = (params) => {
  return connector.updateChain(params);
};

export const addChain = (params) => {
  return connector.updateChain(params);
};

export const disconnect = (callback) => {
  // connector.killSession();
};
